import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
    connect() {
        // Auto-show when the modal element exists and Bootstrap is present
        this._show = this._show.bind(this)
        document.addEventListener("turbo:load", this._show)
        document.addEventListener("turbo:render", this._show)
        this._show()
    }

    disconnect() {
        document.removeEventListener("turbo:load", this._show)
        document.removeEventListener("turbo:render", this._show)
    }

    _show() {
        const el = this.element
        const bs = bootstrap
        if (!el || !bs) return
        const modal = bs.Modal.getOrCreateInstance(el)
        modal.show()
    }
}